// operationalPresenceFeatureFlags.js — mesma forma ja adotada pelo
// projeto para toda capacidade nova sobre producao real ativa
// (cameraFeatureFlags.js, intelligenceOfficerFeatureFlags.js): objeto
// congelado com default deny-by-default e um resolver puro que so aceita
// uma representacao booleana explicita.
//
// Esta flag NAO ativa midia. Ela existe nesta missao (ADR-003, "Arquitetura
// Executavel") apenas para que o Prompt 2 (fundacao LiveKit/Media Plane)
// tenha um unico ponto de ativacao ja preparado — desligada, o
// comportamento atual do REACTA permanece inalterado (ver
// test/backend/operationalPresenceFeatureFlags.test.js e
// test/backend/operationalPresenceStateMapper.test.js).
export const OPERATIONAL_PRESENCE_FEATURE_FLAGS = Object.freeze({ OPERATIONAL_PRESENCE_ENABLED: false });

export function parseBooleanFlag(value) {
  return value === true || value === 'true';
}

// Resolves known flags with deny-by-default semantics; absent or invalid values stay disabled.
export function resolveOperationalPresenceFeatureFlags(source = {}) {
  const hasExplicitValue = source.OPERATIONAL_PRESENCE_ENABLED !== undefined
    && source.OPERATIONAL_PRESENCE_ENABLED !== null
    && String(source.OPERATIONAL_PRESENCE_ENABLED).trim() !== '';
  if (!hasExplicitValue) return OPERATIONAL_PRESENCE_FEATURE_FLAGS;
  return Object.freeze({ OPERATIONAL_PRESENCE_ENABLED: parseBooleanFlag(source.OPERATIONAL_PRESENCE_ENABLED) });
}

export default { OPERATIONAL_PRESENCE_FEATURE_FLAGS, parseBooleanFlag, resolveOperationalPresenceFeatureFlags };
